import { useCallback, useMemo, useRef, useState } from "react";
import { useIntersectionObserver } from "./useIntersectionObserver";

export const useScrollObserver = (threshold = 0) => {
  const [rootNode, setRootNode] = useState<HTMLElement | null>(null);

  const targetRef = useRef<any>(null);

  const containerRef = useCallback((node: HTMLElement | null) => {
    setRootNode(node);
  }, []);

  const options = useMemo(
    () => ({
      root: rootNode,
      threshold,
    }),
    [rootNode, threshold]
  );

  const isIntersecting = useIntersectionObserver(targetRef, options);

  return {
    containerRef,
    targetRef,
    isIntersecting,
  };
};
